import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { usePortal } from '../contexts/PortalContext';
import { brand } from '../data/projects';

/**
 * The only thing between a client and their project: a name, so their comments
 * and approvals can be attributed. No account, no password, no email.
 */
export function Login() {
  const {
    signIn,
    activeProject
  } = usePortal();
  const [name, setName] = useState('');
  return <div className="relative flex min-h-screen w-full items-center justify-center bg-ink px-6 py-20 text-paper" data-id="element-676" data-mp="33etumeg1tist">
      {/* Light grazing a matte black wall, drawn rather than photographed so
          the surface stays perfectly clean. */}
      <div aria-hidden className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(120% 90% at 18% 8%, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0.06) 34%, rgba(255,255,255,0) 68%)'
    }} data-id="element-677" data-mp="2yn20xv1liwyg" />

      <div className="relative w-full max-w-xl" data-id="element-678" data-mp="3r5h4v6dfskij">
        <img src={brand.lockup} alt="Portal Productions" className="h-8 w-auto brightness-0 invert sm:h-10" data-id="element-679" data-mp="2ri3wm7pg947x" />

        <h1 className="mt-20 font-display text-4xl leading-[0.98] tracking-tight sm:text-6xl" data-id="element-680" data-mp="2mg4q4oyexr6r">
          Welcome to
          <br data-id="element-681" data-mp="2wgf5og7x7ap3" />
          your project.
        </h1>

        <p className="label mt-8 text-paper/40" data-id="element-682" data-mp="2wekkr1wnfil0">
          {activeProject.client.toUpperCase()} · {activeProject.name.toUpperCase()}
        </p>

        <form onSubmit={event => {
        event.preventDefault();
        signIn(name);
      }} className="mt-12 max-w-xs" data-id="element-683" data-mp="358pgnzqn3k7e">
          <label className="block" data-id="element-684" data-mp="3k3nakx1fshql">
            <span className="label block text-paper/50" data-id="element-685" data-mp="3f6wmbmfhafu3">Your Name</span>
            <input value={name} onChange={event => setName(event.target.value)} autoFocus autoComplete="name" className="mt-4 w-full border-b border-paper/30 bg-transparent pb-3 font-display text-3xl text-paper focus:border-paper focus:outline-none sm:text-4xl" data-id="element-686" data-mp="3f4sh915ufas8" />
          </label>

          <button type="submit" disabled={!name.trim()} className="label group mt-7 flex w-full items-center justify-between gap-6 border border-paper px-8 py-5 text-paper transition-colors duration-150 ease-out hover:bg-paper hover:text-ink disabled:border-paper/25 disabled:text-paper/30 disabled:hover:bg-transparent disabled:hover:text-paper/30" data-id="element-687" data-mp="2ej4hkwk18txa">
            Continue
            <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={1.25} data-id="element-688" data-mp="2xfdydrmbjykz" />
          </button>

          <p className="label-sm mt-6 leading-relaxed text-paper/30" data-id="element-689" data-mp="3794m2uamg4zm">
            No account needed. We&rsquo;ll remember your name on this device.
          </p>
        </form>

        <p className="mt-20 font-display text-base italic text-paper/35" data-id="element-690" data-mp="3h5zh337orn95">Step through the portal</p>
      </div>
    </div>;
}